/* eslint-disable */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './index.less';


@inject('dashboardStore')
@observer
class H5Card extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	}
	componentDidMount() {
   
  }
	render() {
		const h5List = window.tms.firstDescListLeft;
		const h5DiscountList = window.tms.firstDiscountsExplainList;
		let textArr = this.props.goods;
		textArr = textArr.filter(item => item.exts.keys && item.exts.keys.value); //去掉没有配置的项
		return (
			<div className="h5-card-wrap">
				<div className="h5-card">
					<div className="h5-card-top">
						<p className="h5-card-title">{window.tms.moduleinfo.fristFloor}</p>
						<p className="h5-card-second-title">{window.tms.moduleinfo.firstTitle}</p>
						<div className="h5-card-desc">
							<ul className="desc-left">
								{h5List.map((item, index) => {
									return (
										<li className="desc-left-li" key={index}><span className="point">·</span><span className="point-desc">{item.descLeft}</span></li>
									)
								})}
							</ul>
						</div>
					</div>
					<div className="h5-card-bottom">
						<h3 className="big-bottom-title">套餐产品</h3>
						{textArr.map((item) => {
							return (
								<div key={item.id}>
									<p className="bottom-title">{item.name}</p>
									<p className="bottom-desc">{item.description}</p>
								</div>
							)
						})}
						<h3 className="big-bottom-title">优惠规则</h3>
						{h5DiscountList.map((item, index) => {
							return (
								<p className="bottom-desc-discount" key={index}>{index + 1}、{item.discount}</p>
							)
						})}
					</div>
				</div>
			</div>
		);
	}
}

export default H5Card;


// WEBPACK FOOTER //
// ./src/scripts/components/H5Card/h5.js